import { createRouter, createWebHashHistory } from "vue-router";
import Event from "../views/Events.vue";
import Invitations from "../views/Invitations.vue";
import EventDetail from "../views/EventDetail.vue";
import ScanAttendee from "../views/ScanAttendee.vue";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import AboutView from "../views/AboutView.vue";
import Help from "../views/Help.vue";
import Unauthorized from "../views/Unauthorized.vue";
import Users         from "../views/Users.vue";
import EmailTemplate from "../views/EmailTemplate.vue";
import axios from "axios";

// Route definitions
const routes = [
  {
    path: "/",
    name: "home",
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
    component: Event,
  },
  {
    path: "/events/:id",
    name: "event-detail",
    component: EventDetail,
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
    props: true,
  },
  {
    path: "/Invitation",
    name: "invitation",
    meta: { requiresAuth: true, allowedRoles: ["Admin", "Operator"] },
    component: Invitations,
  },
  {
    path: "/scan-attendee",
    name: "scan-attendee",
    meta: { requiresAuth: true, allowedRoles: ["Operator", "Admin"] },
    component: ScanAttendee,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
    component: Dashboard,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
  },
  {
    path: "/help",
    name: "help",
    component: Help,
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
  },
  {
    path: "/users",
    name: "users",
    component: Users,
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
  },
  {
    path: "/email-template",
    name: "email-template",
    component: EmailTemplate,
    meta: { requiresAuth: true, allowedRoles: ["Admin"] },
  },
  {
    path: "/unauthorized",
    name: "unauthorized",
    component: Unauthorized,
    meta: { requiresAuth: true, allowedRoles: ["Admin", "Operator"] },
  },
  // Catch-all 404 route (optional)
  {
    path: "/:pathMatch(.*)*",
    redirect: "/unauthorized",
  },
];

// Create router
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// Navigation guard with token expiration check
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  // Check token expiration (if exists)
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const now = Math.floor(Date.now() / 1000);
      if (payload.exp && payload.exp < now) {
        console.warn("JWT expired");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        return next("/login");
      }
    } catch (e) {
      console.error("Invalid JWT format", e);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return next("/login");
    }
  }

  // If route requires authentication and no token, redirect to login
  if (to.meta.requiresAuth && !token) {
    return next("/login");
  }

  // If role is not allowed
  if (to.meta.allowedRoles && (!user || !to.meta.allowedRoles.includes(user.role))) {
    return next("/unauthorized");
  }

  // Set Axios Authorization header globally
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  next();
});

export default router;
